var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa",class:[_vm.iconNameCard],style:([_vm.isStyle?_vm.styleObject:'',{fontSize:_vm.size+'px'}]),on:{"click":_vm.trigger}},[_c('div',{staticClass:"fa",class:[_vm.iconName,!_vm.isHover?'iconItemDefault':'iconItem'],attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018b0d3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backstageManagement/public/fontIconComm/fontIconComm.vue
// module id = null
// module chunks = 